import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SocialSharing } from "@ionic-native/social-sharing/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { IonicStorageModule } from "@ionic/storage";
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Geolocation } from "@ionic-native/geolocation/ngx";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { fancyAnimation } from "./animations";
import { QRCodeModule } from "angularx-qrcode";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from "./components/loader/loader.component";
import { FeedbackWidgetComponent } from "./components/feedback-widget/feedback-widget.component";

import { provideLottieOptions } from "ngx-lottie";
import player from "lottie-web";
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule } from '@angular/common/http';

// import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
// import { NOTIFICATION_SOCKET_PORT } from 'src/environments/environment';

// const config: SocketIoConfig = { url: NOTIFICATION_SOCKET_PORT, options: {} };

// ln -s SHARED NODE MODULE

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    // IonicStorageModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    LoaderComponent,
    FeedbackWidgetComponent,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    })
  ],
  providers: [
    InAppBrowser,
    SocialSharing,
    // SplashScreen,
    QRCodeModule,
    Geolocation,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideLottieOptions({
      player: () => player,
    }),
  ],
})
export class AppModule { }


